var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',[_c('h1',[_vm._v("Invoices")]),_c('v-card',{attrs:{"title":"Outstanding Invoices"}},[_c('v-table',{attrs:{"table":_vm.outstanding}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }